import { useMutation } from 'react-query';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';

import api from '@API/api';
import { dialogTypes } from '@/constants/alertTypes';
import { AddAlertParams } from '@mpm-druid/types';
import alertsUtil from '@/util/alertsUtil';

const addAlert = (restParams: AddAlertParams) => {
  return api.post(`/mpm/v2/monitors`, restParams);
};

export function useAddAlertMutation() {
  const history = useHistory();
  const dispatch = useDispatch();

  return useMutation((params: AddAlertParams) => addAlert(params), {
    onSuccess: async () => {
      history.push('./rules');
    },
    onError: (error: Error) => {
      dispatch(
        alertsUtil.openErrorDialog(
          dialogTypes.ERROR_ALERT_CREATED,
          error?.message
        )
      );
    }
  });
}
